import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFileUrl(fileId) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!fileId) {
      setUrl(null);
      return undefined;
    }
    let obj;
    let alive = true;
    api.get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((r) => {
        obj = URL.createObjectURL(r.data);
        if (alive) setUrl(obj);
      })
      .catch(() => alive && setUrl(null));
    return () => {
      alive = false;
      if (obj) URL.revokeObjectURL(obj);
    };
  }, [fileId]);
  return url;
}

export function AuthImage({ fileId, alt, className, testid }) {
  const url = useFileUrl(fileId);
  if (!url) return <div className={`animate-pulse bg-muted ${className}`} data-testid={testid} />;
  return <img src={url} alt={alt} className={`object-cover ${className}`} data-testid={testid} />;
}
